export default "__VITE_ASSET__08c2627b__"